import { css, Global } from '@emotion/react';

import Theme from '.';

const GlobalThemeStyles = () => (
  <Global
    styles={css`
      a,
      button,
      input,
      select,
      textarea {
        &:focus,
        &:focus-visible {
          outline-color: ${Theme.colors.brand};
        }
      }
      a:hover {
        color: ${Theme.colors.brand};
      }
    `}
  />
);

export default GlobalThemeStyles;
